/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import type { NoticeText } from '../../types';
import { StyledRichText } from './StyledRichText';

export interface NoticeLayerProps {
  texts: NoticeText[];
  onContentLinkClicked?: () => void;
}

export const NoticeLayer: React.FC<NoticeLayerProps> = (props) => {
  const { texts, onContentLinkClicked } = props;

  const onNotificationClick = (event: React.MouseEvent<HTMLElement>) => {
    const clickTarget = event.target as HTMLElement;
    if (onContentLinkClicked && clickTarget.tagName === 'A') {
      onContentLinkClicked();
    }
  };

  return (
    <div
      data-test-id="social-media-forwarding-notice"
      onClick={onContentLinkClicked ? onNotificationClick : undefined}
    >
      {texts.map((text) => {
        const markdown = text.noticeText
          .replace(/{{countrySite}}/gi, `**${text.countrySite}**`)
          .replace(
            /{{otherSitesLink}}/gi,
            `[${text.otherSitesLinkCaption}](${text.otherSitesLinkUrl})`,
          );
        return (
          <StyledRichText
            lang={text.language}
            key={`notice-${text.language}`}
            className="notice-item"
            forceBlock
            markdown={markdown}
          />
        );
      })}
    </div>
  );
};
